import TagList from './TagList';

export default {
  list: TagList,
};
